import { render, staticRenderFns } from "./chateau-phelan-segur.vue?vue&type=template&id=23e6d600&scoped=true"
import script from "./chateau-phelan-segur.vue?vue&type=script&lang=js"
export * from "./chateau-phelan-segur.vue?vue&type=script&lang=js"
import style0 from "./chateau-phelan-segur.vue?vue&type=style&index=0&id=23e6d600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e6d600",
  null
  
)

export default component.exports